export default "__VITE_ASSET__D3wQu03W__"